import { useContext, useState } from 'react';
import MetricsInspectionContext from '../../state/context';
import { getParamKeysByMetricName } from './utils';
import { BRANCHES_MODEL } from '../useTableLayout/useBranchesLayout/branches.model';

const DIRS = {
  ASC: 'asc',
  DESC: 'desc'
};

const useTableSortBy = () => {
  const {
    state: { metricName }
  } = useContext(MetricsInspectionContext);

  const { orderByKey = BRANCHES_MODEL.NAME } =
    getParamKeysByMetricName(metricName);

  const [tableSortBy, setTableSortBy] = useState({
    key: orderByKey,
    dir: DIRS.DESC
  });

  const onChange = ({ key, dir }) => setTableSortBy({ key, dir });

  return {
    ...tableSortBy,
    onChange
  };
};

export default useTableSortBy;
